<layer-header
  (closeLayer)="cancel()"
  [listIcons]="false"
  [title]="requirement.id ? 'Edit Document' : 'Add Document'"
>
  <ng-content></ng-content>
</layer-header>

<div class="row" style="margin:0;">
  <div class="col-12">
    <form name="itemForm" class="form-validation">
      <div class="form-group">
        <div class="row">
          <div *ngIf="requirement" class="col-12">
            <label class="input-label field-required">{{
              'annexes.docs.name' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              name="name"
              [(ngModel)]="requirement.name"
              placeholder="{{ 'annexes.doc.name_placeholder' | translate }}"
              #name="ngModel"
              [rangeLength]="[2, 256]"
              required
              autofocus
            />
            <p
              class="validation-error"
              *ngIf="name.errors?.required && (name?.dirty && name?.touched)">
              {{ 'form.validate.required' | translate }}
            </p>
            <p class="validation-error" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
              {{ 'form.validate.minLenght' | translate }} 2!
            </p>
            <p class="validation-error" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
              {{ 'form.validate.maxLenght' | translate }} 256!
            </p>
          </div>
        </div>
      </div>
      <div class="row mb-3" *ngIf="requirement">
        <div class="col">
          <i
            *ngIf="requirement.fileId"
            (click)="download()"
            tooltip="{{ 'Download file' | translate }}"
            download
            style="cursor:pointer"
            class="fas fa-file btn-md btn-bordered btn-dark btn-icon"
          ></i>
          <i
            *ngIf="requirement.fileId"
            tooltip="{{ 'Erase file' | translate }}"
            class="fas fa-eraser btn-md btn-bordered btn-danger btn-icon"
            style="margin-inline-start:1rem;cursor:pointer"
            (click)="deleteFile(false)"
          ></i>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <primary-text-button
            [noLeftPadding]="true"
            (onClick)="save()"
            [disabled]="isLoading || !requirement.name || (requirement.name && requirement.name.length < 2)"
          >
            {{ 'Save' | translate }}
          </primary-text-button>
          <cancelary-text-button (click)="cancel()" type="button">
            {{ 'Cancel' | translate }}
          </cancelary-text-button>
          <confirmation
            [buttonName]="'general.delete'"
            [question]="'confirm.areyousure'"
            (isConfirmed)="deleteRequirement($event)"
            *ngIf="requirement?.id != undefined"
          ></confirmation>
        </div>
      </div>
    </form>
  </div>
</div>
